import React, { PropsWithChildren } from 'react';
import { useStyletron } from 'styletron-react';
import ScrollIndicator from './scroll-indicator';

interface Props {
  sectionName: string;
}

const FullViewHeightSection: React.FC<PropsWithChildren<Props>> = ({ children, sectionName }) => {
  const [css] = useStyletron();

  return (
    <section className={`${sectionName} d-flex position-relative`}>
      <ScrollIndicator
        className={
          'mouse_scroll_show position-absolute bottom-0 start-50 ' +
          css({
            zIndex: 50, // necessary to enable the CTA to be placed "above" explicitly
            transform: 'translate(-50%, 0)',
            WebkitTransform: 'translate(-50%, 0)',
            msTransform: 'translate(-50%, 0)'
          })
        }
      />

      {children}
    </section>
  );
};

export default FullViewHeightSection;
